function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".link_svg__a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "link_svg__a",
  d: "M8.204 10.892a4.5 4.5 0 006.786.486l2.7-2.7a4.5 4.5 0 10-6.363-6.363L9.779 3.857"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "link_svg__a",
  d: "M11.807 9.098a4.5 4.5 0 00-6.786-.486l-2.7 2.7a4.5 4.5 0 106.363 6.363l1.538-1.539"
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.008,
    height: 19.99,
    viewBox: "0 0 20.008 19.99"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC4wMDgiIGhlaWdodD0iMTkuOTkiIHZpZXdCb3g9IjAgMCAyMC4wMDggMTkuOTkiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjk5MyAtMi4wMDgpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTE1LDEyLjlhNC41LDQuNSwwLDAsMCw2Ljc4Ni40ODZsMi43LTIuN2E0LjUsNC41LDAsMSwwLTYuMzYzLTYuMzYzTDE2LjU3NSw1Ljg2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuODAzKSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTMuOCwxNS4zYTQuNSw0LjUsMCwwLDAtNi43ODYtLjQ4NmwtMi43LDIuN2E0LjUsNC41LDAsMSwwLDYuMzYzLDYuMzYzbDEuNTM4LTEuNTM5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC00LjE5NCkiLz48L2c+PC9zdmc+";
export { SvgLink as ReactComponent };